import { useParams } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import MobileForm from "../../../../components/MobileForm";

const WindowAndDoor = () => {
  const { version } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <div>
      <MobileForm
        type="windowAndDoor"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
    </div>
  );
}

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="Window And Door">
      <WindowAndDoor />
    </PrivateContent>
  );
};

export default Page;